/*
 * <category-slider> — arrow navigation + arrow enable/disable state for the
 * category slider section. The track scrolls horizontally with CSS scroll-snap;
 * the arrows scroll by roughly one "page" (the visible width).
 */
(function () {
  if (window.customElements && customElements.get('category-slider')) return;

  class CategorySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cat-track]');
      if (!this.track) return;

      const root = this.closest('.hv-cat-slider') || this;
      this.prevBtn = root.querySelector('[data-cat-prev]');
      this.nextBtn = root.querySelector('[data-cat-next]');

      this.onScroll = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByPage(1));

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByPage(direction) {
      // Scroll by ~90% of the visible width so a little of the next item peeks.
      const amount = this.track.clientWidth * 0.9 * direction;
      this.track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      const atStart = x <= 2;
      const atEnd = x >= maxScroll - 2;
      const noOverflow = maxScroll <= 2;

      if (this.prevBtn) this.prevBtn.disabled = atStart || noOverflow;
      if (this.nextBtn) this.nextBtn.disabled = atEnd || noOverflow;
    }
  }

  customElements.define('category-slider', CategorySlider);
})();
